/*
 * $Id:: service.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

/**
 *
 * @param {string} s
 * Return encoded string
 */
export const encodeString = (s) => {
    return encodeURIComponent(s);
};

/**
 * Get a url string with params and return it as object
 * @param {string} s
 * @returns {object}
 */
export const stringUrlToObject = (s) => {
    let objParams = {};
    for (const param of s
        .trim()
        .replace(/^[?#&]/, '')
        .split('&')) {
        if (param.indexOf('=') === -1) {
            return param;
        }

        let [key, value] = param.split('=');
        if (key) {
            objParams[key] = value;
        }
    }
    return objParams;
};

/**
 *
 * @param {object} queryObject
 * Getting an object with key:value and return an encoding string
 *
 */
export const encodeGetParams = (queryObject) => {
    let returnStringParams = '';
    if (Object.keys(queryObject).length !== 0 && queryObject.constructor === Object) {
        returnStringParams =
            '?' +
            Object.entries(queryObject)
                .map((kv) => kv.map(encodeString).join('='))
                .join('&');
    } else {
        returnStringParams = queryObject;
    }

    return returnStringParams;
};

/**
 *
 * @param {string} s
 * Get the url string ?key=value&key=value and return it encoded
 *
 */
export const encodeGetParamsString = (s) => {
    return encodeGetParams(stringUrlToObject(s));
};

// Based on https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
const emailRegexp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export const body2formBody = (body) => {
    const formBody = Object.keys(body).map((key) => {
        return `${encodeURIComponent(key)}=${encodeURIComponent(body[key])}`;
    });
    return formBody.join('&');
};

export const isEmail = (email) => emailRegexp.test(email);

const numberRegexp = /^[1-9]\d*$/;

export const isNumber = (number) => numberRegexp.test(number);

export const capitalize = (text) => {
    return text
        .toLowerCase()
        .trim()
        .split(' ')
        .map((i) => i[0].toUpperCase() + i.substr(1))
        .reduce((ac, i) => `${ac} ${i}`);
};

export const text2CamelCase = (text) => {
    return text
        .toLowerCase()
        .trim()
        .split(' ')
        .map((i, idx) => (idx > 0 ? i[0].toUpperCase() + i.substr(1) : i[0] + i.substr(1)))
        .reduce((cs, i) => `${cs}${i}`);
};

export const base64ToBlobPdf = (base64) => {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; ++i) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return new Blob([bytes], { type: 'application/pdf' });
};

export const userCan = (authorities, type) => authorities && authorities.includes(type);
